import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const FacebookInvertedRoundSVG = styled(Icon).attrs({ viewBox: '0 0 20 20' })`
    width: 1em;
`;

function FacebookInvertedRoundIcon({ color = 'currentColor', ...props }) {
    return (
        <FacebookInvertedRoundSVG data-test="icon-facebook-inverted" {...props}>
            <path
                d="M20 10.058A10 10 0 108.433 20v-7.033h-2.5v-2.909h2.5V7.842c0-2.5 1.5-3.909 3.784-3.909.748.024 1.495.102 2.233.234v2.5h-1.258a1.45 1.45 0 00-1.626 1.575v1.883h2.767l-.441 2.908h-2.325V20A10.05 10.05 0 0020 10.058z"
                fill={color}
                fillRule="nonzero"
            />
        </FacebookInvertedRoundSVG>
    );
}

export { FacebookInvertedRoundIcon as default, FacebookInvertedRoundIcon };
